import {
  faEye,
  faFileExport,
  faPencilAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import ReactTable from "react-table";
import { Button, Col, Container, Row } from "reactstrap";
import BaseAlphabeticInput from "../../../../toolkit/baseAlphabeticInput";
import BaseButtonWithIconAndTooltip from "../../../../toolkit/baseButtonWithIconAndTooltip";
import BaseInput from "../../../../toolkit/baseInput";
import BaseNumericInput from "../../../../toolkit/baseNumericInput";
import { handleRequestError } from "../../../../utils/helpers";
import {
  errorNotification,
  infoNotification
} from "../../../../utils/notifications";
import { getClubsRequest } from "../../../actions/catalogs";
import {
  getEmployeesReport,
  getEmployeesReportCsv
} from "../../../actions/employeesReport";
import s from "./styles.scss";

interface Props {
  userContext: { clubSessionId: any };
}

interface State {
  personaId: string;
  numeroEmpleado: string;
  nombre: string;
  usuarioEstatus: string;
  clubId: String;
  loading: boolean;
  downloading: boolean;
  employees: any[];
  clubs: any[];
}

class EmployeesReportSearch extends React.Component<Props, State> {
  state = {
    employees: [],
    clubs: [],
    personaId: null,
    numeroEmpleado: null,
    usuarioEstatus: null,
    clubId: null,
    nombre: null,
    loading: false,
    downloading: false
  };

  componentDidMount() {
    this.getClubs();
    this.search();
  }

  getClubs = () => {
    getClubsRequest()
      .then(({ data }) => {
        this.setState({ clubs: (data || []).filter(x => !!x.migradoCrm2) });
      })
      .catch(handleRequestError);
  };

  search = () => {
    const {
      personaId,
      numeroEmpleado,
      nombre,
      usuarioEstatus,
      clubId
    } = this.state;

    infoNotification("Consultando reporte...");

    this.setState({ loading: true });
    getEmployeesReport({
      personaId: personaId || null,
      numeroEmpleado: numeroEmpleado || null,
      nombre: nombre || null,
      usuarioEstatus: usuarioEstatus || null,
      clubId: clubId || null
    })
      .then(({ data }) => {
        this.setState({
          loading: false,
          employees: [...data]
        });
      })
      .catch(() => {
        errorNotification("Error al consultar el reporte.");
        this.setState({
          loading: false,
          employees: []
        });
      });
  };

  render() {
    return (
      <Container className="p-0">
        <Row>
          <Col xs={12} md={1} lg={1}>
            <BaseNumericInput
              label="Persona Id"
              name="personaId"
              id="personaId"
              type="text"
              placeholder="Persona Id"
              value={this.state.personaId}
              onChange={e => {
                const value = e.target.value;
                this.setState({ personaId: value });
              }}
              size={"sm"}
            />
          </Col>

          <Col xs={12} md={1} lg={1}>
            <BaseNumericInput
              label="Num. Empleado"
              name="numeroEmpleado"
              id="numeroEmpleado"
              type="text"
              placeholder="Número empleado"
              value={this.state.numeroEmpleado}
              onChange={e => {
                const value = e.target.value;
                this.setState({ numeroEmpleado: value });
              }}
              size={"sm"}
            />
          </Col>

          <Col xs={12} md={3} lg={3}>
            <BaseAlphabeticInput
              label="Nombre"
              name="nombreEmpleado"
              id="nombreEmpleado"
              type="text"
              placeholder="Nombre"
              value={this.state.nombre}
              onChange={e => {
                const value = e.target.value;
                this.setState({ nombre: value });
              }}
              size={"sm"}
            />
          </Col>

          <Col xs={12} md={2} lg={2}>
            <BaseInput
              label="Estatus usuario"
              name="usuarioEstatusEmpleado"
              id="usuarioEstatusEmpleado"
              type="select"
              placeholder="Seleccionar"
              value={this.state.usuarioEstatus}
              onChange={e => {
                const value = e.target.value;
                this.setState({ usuarioEstatus: value });
              }}
              size={"sm"}
              options={[
                { value: "", label: "Seleccionar" },
                { value: "ACTIVE", label: "ACTIVO" },
                { value: "SUSPENDED", label: "SUSPENDIDO" }
              ]}
            />
          </Col>

          <Col xs={12} md={2} lg={2}>
            <BaseInput
              label="Club"
              name="club"
              id="club"
              type="select"
              placeholder="Seleccionar"
              value={this.state.clubId}
              onChange={e => {
                const value = e.target.value;
                this.setState({ clubId: value });
              }}
              size={"sm"}
              options={[{ value: "", label: "Seleccionar" }].concat(
                (this.state.clubs || []).map(option => ({
                  value: option.clubId,
                  label: option.nombre
                }))
              )}
            />
          </Col>

          <Col xs={12} md={1} lg={1} className="mt-4">
            <Button
              size="sm"
              className={`float-right btn-block`}
              onClick={e => {
                e.preventDefault();
                this.search();
              }}
            >
              {this.state.loading ? "Buscando..." : "Buscar"}
            </Button>
          </Col>
        </Row>

        {!!(this.state.employees || []).length && (
          <Row className={"mt-5 mb-3"}>
            <Col sm="6">
              Resultados de la búsqueda:{" "}
              <b
                style={{ fontWeight: "bolder", display: "inline-block" }}
                className="ml-3"
              >
                {(this.state.employees || []).length}
              </b>
            </Col>
            <Col sm="6" className="text-right">
              <span>Exportar a CSV: </span>
              <Button
                id="btnReportExportCsv"
                color="link"
                onClick={() => {
                  const {
                    personaId,
                    numeroEmpleado,
                    nombre,
                    usuarioEstatus,
                    clubId
                  } = this.state;

                  infoNotification("Descargando reporte...");

                  getEmployeesReportCsv(
                    {
                      personaId: personaId || null,
                      numeroEmpleado: numeroEmpleado || null,
                      nombre: nombre || null,
                      usuarioEstatus: usuarioEstatus || null,
                      clubId: clubId || null
                    },
                    () => {}
                  );
                }}
              >
                <FontAwesomeIcon icon={faFileExport} color="black" />
              </Button>
            </Col>
          </Row>
        )}

        <ReactTable
          data={this.state.employees}
          columns={[
            {
              Header: () => <p className="font-weight-bold">ID</p>,
              id: 0,
              width: 100,
              accessor: "personaId",
              className: "text-center"
            },
            {
              Header: () => <p className="font-weight-bold">NOMBRE</p>,
              id: 0,
              width: 280,
              accessor: "nombre"
            },
            {
              Header: () => <p className="font-weight-bold">SEXO</p>,
              id: 0,
              width: 150,
              accessor: "sexo",
              className: "text-center"
            },
            {
              Header: () => <p className="font-weight-bold">FEC. NAC.</p>,
              id: 0,
              width: 150,
              accessor: "fechaNac",
              className: "text-center"
            },
            {
              Header: () => <p className="font-weight-bold">NUM. EMPLEADO</p>,
              id: 0,
              width: 150,
              accessor: "numeroEmpleado",
              className: "text-center"
            },
            {
              Header: () => <p className="font-weight-bold">Club</p>,
              id: 0,
              width: 190,
              accessor: "club",
              className: "text-center"
            },
            {
              Header: () => <p className="font-weight-bold">USUARIO</p>,
              id: 0,
              width: 150,
              accessor: "userName",
              className: "text-center"
            },
            {
              Header: () => <p className="font-weight-bold">PUESTO</p>,
              id: 0,
              width: 200,
              accessor: "userPuestos",
              className: "text-justify"
            },
            {
              Header: () => <p className="font-weight-bold">USUARIO ESTATUS</p>,
              id: 0,
              width: 150,
              accessor: "userEstatus",
              className: "text-center"
            },
            {
              Header: () => (
                <p className="font-weight-bold">ULTIMA ACTUALIZACION</p>
              ),
              id: 0,
              width: 150,
              accessor: "userFechaBaja",
              className: "text-center"
            },
            {
              Header: () => <p className="font-weight-bold">&nbsp;</p>,
              id: 0,
              width: 120,
              Cell: row => {
                return (
                  <Container className="p-0">
                    <Row className="m-0">
                      <Col>
                        <BaseButtonWithIconAndTooltip
                          id={`view${row.original.personaId}`}
                          icon={faEye}
                          size="sm"
                          tooltipTitle="Ver empleado"
                          onClick={() => {
                            window.open(
                              `/empleado/${row.original.personaId}/detalle`,
                              "_blank"
                            );
                          }}
                        />
                      </Col>
                      {/*  <Col>
                          <BaseButtonWithIconAndTooltip
                            id={`edit${row.original.personaId}`}
                            icon={faPencilAlt}
                            size="sm"
                            tooltipTitle="Editar empleado"
                            onClick={() => {
                              window.open(`/empleado/${row.original.personaId}/ver`, "_blank");
                            }}
                          />

                        </Col> */}
                    </Row>
                  </Container>
                );
              }
            }
          ]}
          className="mt-2 -striped -highlight"
          sortable={false}
          resizable={true}
          pageSize={50}
          loading={this.state.loading}
        />
      </Container>
    );
  }
}

export default withStyles(s)(EmployeesReportSearch);
